<template>
  <div class="claim-count-label">
    <common-label>
      <template v-slot:contents>
        <div class="flex items-center">
          <div class="aisea-text-12-600-dark-gray mr-4">{{ itemLabel }}</div>
          <div class="flex items-end text-end">
            <div class="claim-count-text mr-2">{{ count }}</div>
            <div class="aisea-text-18-600-dark-gray">件</div>
          </div>
        </div>
      </template>
    </common-label>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import CommonLabel from "./CommonLabel.vue";

/*
 * 対応中事故件数
 */
export default {
  name: "M.ClaimCountLabel",
  props: {
    itemLabel: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
  },
  mixins: [ColorMixin],
  components: {
    CommonLabel,
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
.claim-count-label {
  .claim-count-text {
    line-height: 1;
    font-size: 40px;
    font-weight: 600;
    font-family: $aisea-font-family;
  }
}
</style>
